
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// the translations
const resources = {

};
i18n.init({
  fallbackLng: ['en', 'fr'],
  debug: true,
  resources: {
    en: {
      translation: {
        'InvalidZip': "Invalid Zip Code",
        'InvalidEmail' : 'Please enter a Valid Email',
        'InvalidPhone' : 'Invalid phone number',
        'RequiredField' :  'Required Field',
        'ContactCityService' : "Veuillez contacter l\'équipe City service"
      }
    },
    fr: {
      translation: {
        'InvalidZip' : "code postal invalide",
        'InvalidEmail' : "Veuillez saisir un e-mail valide",
        'InvalidPhone' : 'Numéro de téléphone invalide',
        'RequiredField' :  'Champs requis',
        'ContactCityService' : "Veuillez contacter l\'équipe City service",
        'Jan':"Janv.",
        'Feb':"Févr.",
        'Mar':"Mars",
        'Apr':"Avril",
        'May':"Mai",
        'Jun ':"Juin",
        'Jul':"Juil.",
        'Aug':"Août",
        'Sepr':"Sept.",
        'Oct':"Oct.",
        'Nov':"Nov.",
        'Dec':"Déc.",
        'Months':"Mois"
      }
    }
  }
});

// initialized and ready to go!
// i18next is already initialized, because the translation resources where passed via init function
if (window.location.href.indexOf("/fr/") > -1) {
  i18n.changeLanguage("fr");
}

export default i18n;
